import '../../sass/template-parts/thicknesses.scss';

(() => {
    const $thicknesses = document.querySelectorAll('.thicknesses');

    if (!$thicknesses) return;

    $thicknesses.forEach($thicknesses => {
        const $fileShare = $thicknesses.querySelector('.thickness-modal__file-share');

        const initFileShare = () => {
            if (!$fileShare) return;

            const { shareUrl, shareTitle } = $fileShare.dataset;

            $fileShare.addEventListener('click', e => {
                if (!shareUrl || !navigator?.share) return;

                e.preventDefault();

                navigator.share({
                    title: shareTitle,
                    url: shareUrl
                }).catch(() => {
                    window.location = $fileShare.href;
                });
            });
        };

        initFileShare();
    });
})();
